export const POINT_COLORS = {
  DEFAULT: '#222222',
  START: '#65B604',
  END: '#DB0000',
}
